/**
 * Created by Ning Jiang on 2021-07-06.
 */

import {GuiButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton";
import {PointerStateColorSet} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet";
import {SvgLoader} from "@nolimitcity/slot-launcher/bin/loader/SvgLoader";
import {GuiDefaultTextures} from "@nolimitcity/slot-launcher/bin/gui/default/GuiDefaultTextures";
import {PointerState} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/PointerState";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";

export class EntryButton extends GuiButton {

    private _text:PIXI.Text;
    private _backplate:PIXI.NineSlicePlane;
    private _colors:PointerStateColorSet;

    private _textFontSize:number;
    private _textLineHeight:number;

    constructor(textStyle:PIXI.TextStyle) {
        super("");

        this._colors = new PointerStateColorSet(
            0xffffff,
            0xB3A188,
            0xB3A188,
            0x999999,
        );

        const bg = new PIXI.Sprite(ImgLoader.getImgTexture("entryButton"));
        bg.anchor.set(0.5, 0.4);
        this.addChild(bg);

        this._backplate = new PIXI.NineSlicePlane(SvgLoader.getSvgTexture(GuiDefaultTextures.PLATE_BASE_9), 9, 9, 9, 9);
        this._backplate.tint = 0xff0000;
        this._backplate.alpha = 0;
        this._backplate.width = 210;
        this._backplate.height = 70;
        this._backplate.position.set(-this._backplate.width * 0.5, -this._backplate.height * 0.5);

        this.hitArea = new PIXI.Rectangle(-105, -35, 210, 70);

        this._textFontSize = <number>textStyle.fontSize;
        this._textLineHeight = textStyle.lineHeight;
        this._text = new PIXI.Text("", textStyle);
        this._text.scale.y = 0.8;
        this._text.anchor.set(0.5);

        this.addChild(this._backplate);
        this.addChild(this._text);
        // this.pivot.set(this._backplate.width * 0.5, this._backplate.height * 0.5);
    }

    public setText(text:string):void {
        this._text.text = text;
        this._text.style.fontSize = this._textFontSize;
        this._text.style.lineHeight = this._textLineHeight;
        while(this._text.height > 70) {
            this._text.style.fontSize--;
            this._text.style.lineHeight--;
        }
        this._text.position.set(this._text.style.fontSize * 0.4, 2);
    }

    protected onPointerStateUpdate = (state:PointerState) => {
        this._text.tint = this._colors.getItem(state);
    };

    public setColor(color:number):void {
        this._text.tint = color;
    }
}